module.exports = __webpack_public_path__ + "static/media/egg-hunter-badge.412604de.svg";